<template lang="pug">
	.flex-col.padding
		DxTextArea(width="100%" :height="300" :value.sync="innerValue")
		.flex-row.full-width.justify.padding.actions-buttons
			.left.flex-row.space
			.right.flex-row.space.align-center
				Loader(v-if="loading", text="")
				DxButton(
					v-show="!isPlaying",
					icon="fas fa-play", type="success",
					:hint="$tCaption('Play suggestion')"
					:text="$tCaption('Play')",
					@click="playText",
					:disabled="loading"
				)
				DxButton(
					v-show="isPlaying",
					icon="fas fa-stop", type="success",
					:hint="$tCaption('Stop', '@actions')"
					:text="$tCaption('Stop')",
					@click="stop",
					:disabled="loading"
				)
				DxButton(
					icon="fas fa-users-cog",
					type="success", stylingMode="text"
					:hint="$tCaption('Open in Creative Studio')"
					:text="$tCaption('Open')",
					:disabled="loading",
					@click="makeCreative"
				)

</template>

<script>
	import DxTextArea from 'devextreme-vue/text-area';
	import DxButton from 'devextreme-vue/button';
	import VueTypes from 'vue-types';
	import Loader from 'app-core/Loader.vue';
	import creativeUpdater from 'view/creative/updater';
	import ssmlHelper from 'view/insertion/ssml-helper'

	export default {
		name: "testStep",
		translationCategory: 'creative.AiScriptBuilder.testStep',
		components: {
			DxTextArea, DxButton, Loader
		},
		props: {
			suggestion: VueTypes.string.def(''),
			attachToCreative: VueTypes.any.def(null)
		},
		data() {
			return {
				player: null,
				isPlaying: false,
				loading: false,
				audioBase64: null,
				innerValue: this.suggestion,
				context: new AudioContext()
			}
		},
		computed: {
			ssml() {
				return ssmlHelper.prepareSsml(`<speak xmlns=\"http://www.w3.org/2001/10/synthesis\" xmlns:mstts=\"http://www.w3.org/2001/mstts\" xmlns:emo=\"http://www.w3.org/2009/10/emotionml\" version=\"1.0\" xml:lang=\"en-US\">
						<voice name=\"en-US-JennyMultilingualNeural\">
							<prosody rate=\"1\" pitch=\"+0%\">${this.innerValue}</prosody>
						</voice>
					</speak>`, { pitch: 1, rate: 1, language: 'en-US', voice: 'en-US-JennyMultilingualNeural' })?.ssml;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.testStep = this;
		},
		methods: {
			loadBase64() {
				return new Promise((res) =>
					this.$Data
						.postExternalApi('Creative/BuildAudioCustom', { Ssml: this.ssml, ClientProcessId: this.$auth.getGlobalProcessId('crt_ai_script_bldr') }).then(r => {
							if (this.player)
								this.player.pause();
							this.audioBase64 = `data:audio/wav;base64,${r.AudioData}`;
							this.player = new Audio();
							this.player.addEventListener('canplaythrough', () => res(), false);
							this.player.addEventListener('error', () => res(), false);
							this.player.src = this.audioBase64;
							if (this.isPlaying) {
								this.player.play();
								this.player.addEventListener('ended', (e) => this.isPlaying = false, false);
							}
						})
						.catch(f => {
							this.isPlaying = false;
							res();
						})
				)
			},
			playText() {
				this.isPlaying = true;
				this.loading = true;
				this.loadBase64().finally(() => this.loading = false);
			},
			stop() {
				if (this.player)
					this.player.pause();
				this.isPlaying = false;
			},
			async makeCreative() {
				try {
					this.loading = true;
					if (!this.audioBase64) {
						await this.loadBase64();
					}
					
					this.loading = true;
					let creativeId = this.attachToCreative?.creativeId;
					let startTime = this.attachToCreative?.startTime || 0;
					let trackNumber = this.attachToCreative?.trackNumber || 0;

					if (!this.attachToCreative?.creativeId) {
						creativeId = (await this.$Data.createUpdateCreative({
							Oid: null,
							Name: 'New creative',
							JsonConfig: {
								creativeVersion: creativeUpdater.CREATIVE_VERSION
							}
						}))?.Data?.Oid;
					}

					let insertion = (await this.$Data.createUpdatePureInsertion({
						Oid: null,
						Voice: 'en-US-JennyMultilingualNeural',
						Language: 'en-US',
						type: 'textToSpeech',
						Ssml: this.ssml,
						CreativeId: creativeId,
						Duration: parseInt(this.player.duration * 1000),
						StartTime: parseInt(startTime * 1000),
						JsonConfig: { trackNumber },
						Rate: 1,
						Pitch: 1
					}))?.Data;
					
					await this.$azure.uploadInsertionAudio(insertion, this.audioBase64);

					this.$router.push({ path: `/creative/Detail/${creativeId}` });
				} finally {
					this.loading = false;
				}
			}
		}
	}
</script>

<style lang='scss' scoped>
	.actions-buttons {
		display: flex;
		flex-direction: row;
		z-index: 1000;
		align-items: center;

		> * {
			margin-right: 4px;
		}
	}

</style>
